import React, { useEffect, useState } from "react";
import {
  Stack,
  Badge,
  BadgeProps,
  Typography,
  Box,
  Tooltip,
  IconButton,
} from "@mui/material";
import theme, { CancelBtnBadge } from "../../assets/theme/theme";
import { styled } from "@mui/system";
import { Link } from "react-router-dom";
import { toDocTypeSlug } from "../../utils/documentUtils";
import { useDocumentUploadContext } from "../../contexts/DocumentUploadContext";
import { IFolder } from "../../contexts/DocumentContext";
import CloseIcon from "@mui/icons-material/Close";
import { useUserContext } from "../../contexts/UserContext";
import { logEvent } from "firebase/analytics";
import { analytics } from "../../firebase";
import FolderPassportIcon from "../Shared/Icons/FolderPassportIcon";

const DocumentCountBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
  "& .MuiBadge-badge": {
    height: 32,
    width: 32,
    right: 0,
    top: 13,
    borderRadius: 16,
    background: theme.palette.success.light,
    color: theme.palette.success.main,
    border: `2px solid ${theme.palette.success.main}`,
    fontSize: 14,
    fontWeight: 600,
  },
}));

const DotBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
  "& .MuiBadge-dot": {
    padding: 0,
    top: 4,
    right: -12,
    zIndex: 1,
    minWidth: "8px",
    width: "8px",
    height: "8px",
    background: theme.palette.primary.main,
    borderRadius: "100%",
    boxShadow: "0 0 0 1px #fff",
  },
}));
export interface Props {
  folder: IFolder;
}
const Folder: React.FC<Props> = (props) => {
  // const [blinkStyle, setBlinkStyle] = useState('') // scale-element-2
  const { recentlyUpdatedDocTypeSignal, clearRecentlyUpdatedDocTypeSignal } =
    useDocumentUploadContext();
  const [addDotBadge, setAddDotBadge] = useState(false);
  const { deleteUserCustomFolder } = useUserContext();

  useEffect(() => {
    // function blink() {
    //   setBlinkStyle('')
    //   setTimeout(() => {
    //     setBlinkStyle('scale-element-3')
    //   }, 0)
    // }

    if (
      recentlyUpdatedDocTypeSignal.recentlyUpdatedDocType ===
      props.folder.docType
    ) {
      // blink()
      setAddDotBadge(true);
    }
  }, [recentlyUpdatedDocTypeSignal, props.folder.docType]);

  const BadgeContent = (
    <DocumentCountBadge
      badgeContent={props.folder.count}
      // className={blinkStyle}
    >
      {props.folder.icon}
    </DocumentCountBadge>
  );

  const onClickDocument = () => {
    logEvent(analytics, "click_folder", { ...props.folder });
    clearRecentlyUpdatedDocTypeSignal();
  };

  // For folder with 0 count, show tooltip to suggest move documents from others folder
  if (props.folder.count <= 0) {
    return (
      <Box
        style={{ color: theme.palette.text.secondary, cursor: "not-allowed" }}
      >
        <Stack
          spacing={1}
          position="relative"
          flexBasis="120px"
          justifyContent="center"
          alignItems="center"
          margin="auto"
        >
          <CancelBtnBadge
            badgeContent={
              <IconButton
                onClick={() => {
                  deleteUserCustomFolder(props.folder.title);
                }}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            }
          >
            <Tooltip followCursor title="This folder is empty">
              <FolderPassportIcon />
            </Tooltip>
          </CancelBtnBadge>
          <Typography textAlign="center">{props.folder.title}</Typography>
        </Stack>
      </Box>
    );
  }

  return (
    <Link
      onClick={onClickDocument}
      to={`/documents/${toDocTypeSlug(props.folder.title)}`}
    >
      <Box
        className="auto-generated-blog"
        display="inline-block"
        style={{ color: theme.palette.text.secondary }}
      >
        <Stack
         className="auto-generated-folder"
          spacing={1}
          p="20px"
          position="relative"
          flexBasis="120px"
          justifyContent="center"
          alignItems="center"
          margin="auto"
        >
          {addDotBadge ? (
            <DotBadge variant="dot" badgeContent={props.folder.count}>
              {BadgeContent}
            </DotBadge>
          ) : (
            <>{BadgeContent}</>
          )}
          <Typography textAlign="center">{props.folder.title}</Typography>
        </Stack>
      </Box>
    </Link>
  );
};
export default Folder;
